// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".a5910b4e19244813851985112b6f4b5a99b63276.chunk.bundle.js";
};